<template>
  <b-container>
    <b-row align-h="end" class="mb-1">
      <b-col md="2">
        <b-button
          class="float-right"
          :to="{ name: 'apps-create' }"
          variant="flat-primary"
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        >
          <feather-icon icon="PlusIcon" />
          اپلیکیشن جدید
        </b-button>
      </b-col>
    </b-row>

    <b-row
      ><b-table
        :items="$store.getters['applications/getUserApps']"
        :fields="fields"
        striped
        hover
      >
        <template #cell(iconUrl)="url">
          <b-img :src="url.value" width="50" height="50" />
        </template>
        <template #cell(show_details)="row">
          <b-button
            v-model="row.detailsShowing"
            variant="flat-primary"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            @click="row.toggleDetails"
          >
            {{ !row.detailsShowing ? 'جزییات' : 'خلاصه' }}</b-button
          >
        </template>

        <!-- <template #cell(show_details)="row">
          <b-form-checkbox
            v-model="row.detailsShowing"
            plain
            class="vs-checkbox-con"
            @change="row.toggleDetails"
          >
            <span class="vs-checkbox">
              <span class="vs-checkbox--check">
                <i class="vs-icon feather icon-check" />
              </span>
            </span>
            <span class="vs-label">{{
              row.detailsShowing ? 'Hide' : 'Show'
            }}</span>
          </b-form-checkbox>
        </template> -->
        <template #row-details="row">
          <b-card>
            <b-row>
              <b-col md="3">
                <span>Detais</span>
              </b-col>
            </b-row>

            <b-col md="6" offset-md="3">
              <b-button
                variant="outline-primary"
                block
                @click="row.toggleDetails"
                >بستن</b-button
              >
            </b-col>
          </b-card>
        </template>
      </b-table>
    </b-row>
  </b-container>

  <!-- <div>
    <div class="col-md-6 float-md-right text-right"></div>
    <div class="col-md-6 float-md-left"></div>
  </div> -->
</template>
<script>
import {
  BRow,
  BCol,
  BContainer,
  BButton,
  BTable,
  BCard,
  BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BContainer,
    BButton,
    BTable,
    BCard,
    BImg,
  },
  data() {
    return {
      // mm: [
      //   {
      //     iconUrl:
      //       'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg',
      //     name: 'تست',
      //   },
      // ],
      fields: [
        {
          key: 'iconUrl',
          label: 'آیکون',
          thStyle: { width: '75px' },
        },
        { key: 'name', label: 'نام' },
        { key: 'show_details', label: '#' },
      ],
    }
  },
  created() {
    this.$store.dispatch('applications/getUserApplications')
  },
}
</script>
